// extracted by mini-css-extract-plugin
export default {"noUserCard":"style_noUserCard__Wh40a"};